var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeSlashIcon = function SvgEyeSlashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#697477",
    fillRule: "evenodd",
    d: "M3.78 2.22a.75.75 0 0 0-1.06 1.06l10.5 10.5a.75.75 0 1 0 1.06-1.06l-1.322-1.323a7 7 0 0 0 2.16-3.11.87.87 0 0 0 0-.567A7.003 7.003 0 0 0 5.32 3.76zm3.196 3.195 1.135 1.136A1.502 1.502 0 0 1 9.95 8.389l1.136 1.135a3 3 0 0 0-4.109-4.109",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#697477",
    d: "m8.312 10.994 1.816 1.816A7.003 7.003 0 0 1 1.88 8.28a.87.87 0 0 1 0-.566 7 7 0 0 1 1.113-2.039l2.513 2.513a3 3 0 0 0 2.806 2.806"
  })));
};
export { SvgEyeSlashIcon as ReactComponent };
export default __webpack_public_path__ + "9a4cae55454391bd7d702b61140dfcc9.svg";